import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FooterComponent } from "./footer/footer.component";
import { MainComponent } from "./main/main.component";
import { CardComponent } from "./main/card/card.component";
import { SharedModule } from "../shared/shared.module";
import { HeaderComponent } from "./header/header.component";
import { TakeawayComponent } from "./takeaway/takeaway.component";
import { DeliveryComponent } from "./delivery/delivery.component";
import { ShoppingCartComponent } from "./shopping-cart/shopping-cart.component";
import { ShoppingItemComponent } from "./shopping-cart/shopping-item/shopping-item.component";
import { ProductCardComponent } from "./product-list/product-card/product-card.component";
import { ProductCategoriesComponent } from "./product-list/product-categories/product-categories.component";
import { CategoryPipe } from "./product-list/pipes/category.pipe";
import { ProductListComponent } from "./product-list/product-list.component";
import { InViewportModule } from "@thisissoon/angular-inviewport"
import { ProductOrderModalComponent } from "./product-list/product-order-modal/product-order-modal.component";
import { ProductOptionsComponent } from "./product-list/product-order-modal/product-options/product-options.component";
import { PhoneComponent } from "./phone/phone.component";
import { CheckoutComponent } from "./checkout/checkout.component";
import { OrderConfirmationComponent } from "./checkout/order-confirmation/order-confirmation.component";
import { DeliveryInformationComponent } from "./checkout/delivery-information/delivery-information.component";
import { BillingInformationComponent } from "./checkout/billing-information/billing-information.component";
import { CheckOutItemComponent } from "./checkout/checkout-item/checkout-item.component";
import { ControlPanelComponent } from "../layouts/admin/control-panel/control-panel.component";
import { ProductsSettingsComponent } from "../layouts/admin/products-settings/products-settings.component";
import { ToppingsSettingsComponent } from "../layouts/admin/toppings-settings/toppings-settings.component";
import { ToppingGroupSettingsComponent } from "../layouts/admin/topping-group-settings/topping-group-settings.component";
import { AddToppingGroupComponent } from "../layouts/admin/add-topping-group/add-topping-group.component";
import { AddProductComponent } from "../layouts/admin/add-product/add-product.component";
import { PlaceInfoComponent } from "../layouts/admin/place-info/place-info.component";
import { AddCategorytComponent } from "../layouts/admin/add-category/add-category.component";
import { CategoriesSettingsComponent } from "../layouts/admin/categories-settings/categories-settings.component";
import { BranchesComponent } from "../layouts/admin/branches/branches.component";
import { OrderResponseComponent } from "./checkout/order-response/order-response.component";

@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    MainComponent,
    CardComponent,
    TakeawayComponent,
    DeliveryComponent,
    ShoppingCartComponent,
    ShoppingItemComponent,
    ProductListComponent,
    ProductCardComponent,
    ProductCategoriesComponent,
    PhoneComponent,
    CategoryPipe,
    ProductOrderModalComponent,
    ProductOptionsComponent,
    CheckoutComponent,
    OrderConfirmationComponent,
    OrderResponseComponent,
    DeliveryInformationComponent,
    BillingInformationComponent,
    CheckOutItemComponent,
    ControlPanelComponent,
    ProductsSettingsComponent,
    PlaceInfoComponent,
    ToppingsSettingsComponent,
    ToppingGroupSettingsComponent,
    AddProductComponent,
    AddToppingGroupComponent,
    AddCategorytComponent,
    CategoriesSettingsComponent,
    BranchesComponent
  ],
  imports: [CommonModule, SharedModule, InViewportModule],
  exports: [
    HeaderComponent,
    FooterComponent,
    MainComponent,
    CardComponent,
    TakeawayComponent,
    PhoneComponent,
    DeliveryComponent,
    ShoppingCartComponent,
    ProductListComponent,
    ProductOrderModalComponent,
    ProductOptionsComponent,
    CheckoutComponent,
    OrderConfirmationComponent,
    OrderResponseComponent,
    DeliveryInformationComponent,
    BillingInformationComponent,
    AddProductComponent,
    AddToppingGroupComponent,
    AddCategorytComponent
  ],
  entryComponents: [
    HeaderComponent,
    FooterComponent,
    MainComponent,
    CardComponent,
    TakeawayComponent,
    PhoneComponent,
    DeliveryComponent,
    ShoppingCartComponent,
    ProductListComponent,
    ProductOrderModalComponent,
    ProductOptionsComponent,
    AddProductComponent,
    AddToppingGroupComponent,
    AddCategorytComponent
  ],
  providers: [CategoryPipe],
})
export class CoreModule { }
